// A complete course list is used so filtering never changes a course color.
const GOLDEN_ANGLE = 137.507764;
function pastel(index) {
  const hue = (210 + index * GOLDEN_ANGLE) % 360;
  const saturation = 0.56;
  const lightness = [0.80, 0.86, 0.90][index % 3];
  const a = saturation * Math.min(lightness, 1 - lightness);
  const channel = (offset) => {
    const k = (offset + hue / 30) % 12;
    return Math.round(255 * (lightness - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))));
  };
  const rgb = [channel(0), channel(8), channel(4)];
  return { rgb, hex: "#" + rgb.map(value => value.toString(16).padStart(2, "0")).join("") };
}
const distance = (a, b) => a.reduce((sum, value, i) => sum + (value - b[i]) ** 2, 0);

export function timetableCourseColors(courses) {
  const ids = [...new Set(courses.map(course => String(course.id)))].sort();
  const candidates = [];
  const seen = new Set();
  // Grow the palette for larger academies; never cycle through eight colors.
  for (let index = 0; candidates.length < Math.max(216, ids.length * 2); index++) {
    const candidate = pastel(index);
    if (!seen.has(candidate.hex)) {
      seen.add(candidate.hex);
      candidates.push({ ...candidate, nearest: Infinity });
    }
  }
  const colors = new Map();
  for (const id of ids) {
    // Spread successive course colors apart rather than taking adjacent hues.
    let best = 0;
    for (let i = 1; i < candidates.length; i++) {
      if (candidates[i].nearest > candidates[best].nearest) best = i;
    }
    const [chosen] = candidates.splice(best, 1);
    colors.set(id, chosen.hex);
    for (const candidate of candidates) {
      candidate.nearest = Math.min(candidate.nearest, distance(candidate.rgb, chosen.rgb));
    }
  }
  return colors;
}
